import React, { useEffect } from 'react'
import ReactGA from 'react-ga'

import { SWRConfig } from 'swr'

import Header from './components/Header'
import Spinner from './components/Spinner'
import { RootProvider } from './context/rootContext'
import Routes from './routes'
import fetcher from './services/fetcher'
import GlobalStyle from './styles/global'

function App () {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'production') {
      ReactGA.pageview(window.location.pathname + window.location.search)
    }
  }, [])

  return (
    <RootProvider>
      <SWRConfig
        value={{
          fetcher
        }}
      >
        <GlobalStyle />
        <Spinner />
        <Header />
        <Routes />
      </SWRConfig>
    </RootProvider>
  )
}

export default App
